import React from 'react';
import { Heart } from 'lucide-react';

const Mission = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="mb-6">
          <Heart size={48} className="mx-auto text-gray-700" />
        </div>
        <h2 className="text-3xl font-light mb-6 text-gray-800">Our Mission</h2>
        <p className="text-lg text-gray-700 leading-relaxed">
          At Diamond Q Jewelers, our mission is to build a community that changes the way the world sees jewelry through the power of integrity, sustainable and eco-conscious practices, and valuing people and the planet over profit.
        </p>
      </div>
    </section>
  );
};

export default Mission;